import React from "react";
import { useFormikContext } from "formik";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import Button from "components/Form/fields/Button";
import classnames from "classnames";
import { disableSubmit, disableReset } from "utils/form";

const DEFAULT_CLASSES = {
  container: "w-100 flex items-center"
};

const FormActions = ({
  children,
  childActions,
  customClasses,
  theme,
  resetCopy,
  submitCopy,
  hideSaveAction,
  onReset,
  reset,
  isSubmitting: controlledIsSubmitting
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const {
    resetForm,
    touched,
    errors,
    isSubmitting,
    submitForm
  } = useFormikContext();

  const ctxIsSubmitting = Boolean(controlledIsSubmitting || isSubmitting);

  const actions = [
    {
      copy: resetCopy || "Reset",
      disabled: disableReset({ isSubmitting: ctxIsSubmitting, touched }),
      onClick: () => {
        reset ? reset() : resetForm();
        onReset && setTimeout(onReset, 0);
      },
      theme,
      classes: {
        contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
      }
    }
  ];

  if (!hideSaveAction) {
    actions.push({
      copy: submitCopy || "Save",
      disabled: disableSubmit({
        isSubmitting: ctxIsSubmitting,
        touched,
        errors
      }),
      loading: ctxIsSubmitting,
      theme,
      onClick: submitForm
    });
  }

  return (
    <div className={classes.container}>
      {children}
      <div className="flex flex-row items-center">
        {childActions}
        {actions.map((action, actionIx) => {
          const isLast = actions.length - 1 === actionIx;
          return (
            <div
              key={actionIx}
              className={classnames("dib", {
                pr2: !isLast
              })}
            >
              <Button {...action} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

FormActions.propTypes = {};

FormActions.defaultProps = {};

export default FormActions;
